module.exports = __webpack_public_path__ + "static/media/28DGC7.b87a57ee.jpg";